module.exports = __webpack_public_path__ + "assets/img/DS-room3 (13).e72c40eb.jpg";